/**
 * @class
 * @description Measure unit model
 * 
 */

export class Unit {

    /**
     * 
     * @param {string} label Unit label (e.g. °C) 
     * @param {number} mul Used unit multiple (e.g. °C -> 1, °mC 0.001 )
     */
    constructor(label, mul){
        this.label = label;
        this.mul = mul;
    }
}

/**
 * @class
 * @description Model for the label to display on map
 * 
 */
 export class Measure {

    /**
     * 
     * @param {string} name ID measure used inside telemtry samples
     * @param {string} label Measure label to show
     * @param {Array<string>} dimensions Array of dimensions ids (e.g. "x", "y", "z")
     * @param {Unit} unit  Unit label
     */
    constructor(id, label, dimensions, unit) {
        this.id = id;
        this.label = label;
        this.dimensions = dimensions;
        this.unit = unit;
    }

    /**
     * 
     * @returns Serialized JSON object
     */
    serialize(){
        return {
            id: this.id,
            label: this.label,
            dimension: this.dimensions,
            unit: {
                label: this.label,
                mul: this.mul
            }
        };
    }

    /**
     * 
     * @param {any} rawObject Serialized object
     * @returns Measure instance
     */
    static deserialize(rawObject){
        return new Measure(
            rawObject.id,
            rawObject.label,
            rawObject.dimensions,
            new Unit(rawObject.label, rawObject.mul)
        );
    }
}  

        // dimensions: Array(3)
        // 0: "x"
        // 1: "y"
        // 2: "z"
        // length: 3
        // __ob__: Observer {value: Array(3), dep: Dep, vmCount: 0}
        // [[Prototype]]: Array
        // id: "mag"
        // label: "Magnetometer (mgauss)"
        // scalar: false
        // unit: Object
        // label: "gauss"
        // value: 0.001